import { createSlice } from '@reduxjs/toolkit';
import { fetchScholarships, fetchScholarshipById, createScholarship, updateScholarship, addInstallment, deleteScholarship } from '../thunks/scholarshipThunks';

const initialState = {
  scholarships: [],
  selectedScholarship: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 0
  },
  installmentError: null,
};

const scholarshipSlice = createSlice({
  name: 'scholarship',
  initialState,
  reducers: { },
  extraReducers: (builder) => {
    builder
      .addCase(fetchScholarships.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchScholarships.fulfilled, (state, action) => {
        state.scholarships = action.payload.data?.scholarships;
        state.pagination = action.payload.data?.pagination;
        state.loading = false;
      })
      .addCase(fetchScholarships.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(fetchScholarshipById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchScholarshipById.fulfilled, (state, action) => {
        state.selectedScholarship = {
          ...(action.payload?.data?.scholarship || {}),
          pendingApprovalRequest: action.payload?.data?.pendingApprovalRequest || null,
        };
        state.loading = false;
      })
      .addCase(fetchScholarshipById.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })    
      .addCase(createScholarship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createScholarship.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createScholarship.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(updateScholarship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateScholarship.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateScholarship.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(addInstallment.pending, (state) => {
        state.loading = true;
        state.installmentError = null;
      })
      .addCase(addInstallment.fulfilled, (state, action) => {
        state.loading = false;
        state.installmentError = null;
      })
      .addCase(addInstallment.rejected, (state, action) => {
        state.installmentError = action.payload;
        state.loading = false;
      })
      .addCase(deleteScholarship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteScholarship.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteScholarship.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });   
  }     
});

export const scholarshipAction = scholarshipSlice.actions;
export default scholarshipSlice.reducer; 
